import CasChangesTable, { IChangesTabProps } from '../CasChangesTable/CasChangesTable';
// utils
import { getCMEFormInfo } from './getCMEFormInfo';

const TYPE_OPTIONS = [
  { name: 'Account', id: 'Account' },
  { name: 'Sales Code', id: 'Sales Code' },
  { name: 'Schedule', id: 'Schedule' },
  { name: 'Addit Clearing', id: 'Addit Clearing' },
  { name: 'Source', id: 'Source' },
];

export default function CMEChangesTab(props: IChangesTabProps) {
  return (
    <CasChangesTable
      entity='Cme/CommissionChanges'
      typeOptions={TYPE_OPTIONS}
      getEditRowInfo={getCMEFormInfo}
      {...props}
    />
  );
}
